<script setup>
import { computed } from 'vue';

const props = defineProps({
  currentFilter: {
    type: String,
    default: 'all',
  },
  filters: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:filter']);

const selectFilter = key => {
  emit('update:filter', key);
};

const isSelected = key => {
  return props.currentFilter === key;
};
</script>

<template>
  <div class="flex items-center gap-1.5 overflow-x-auto pb-1 scrollbar-thin">
    <button
      v-for="filter in filters"
      :key="filter.key"
      class="flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap transition-colors duration-150 border-0 cursor-pointer"
      :class="
        isSelected(filter.key)
          ? 'bg-woot-500 text-white'
          : 'bg-n-solid-2 text-n-slate-11 hover:bg-n-solid-3'
      "
      @click="selectFilter(filter.key)"
    >
      <span>{{ filter.label }}</span>
      <span
        v-if="filter.count != null && filter.count > 0"
        class="text-[10px] opacity-75"
      >
        ({{ filter.count }})
      </span>
    </button>
  </div>
</template>
